import React from 'react';
import { useTheme } from '@mui/material';
import { Fab } from '../../components';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import theme from '../../config/theme';

type PropTypes = {
  handleSlide: any;
};

export default function cardHistoryButton(props: PropTypes) {
  const { handleSlide } = props;
  const { palette }: any = useTheme();

  const handleClickNext = () => {
    handleSlide('next');
  };

  const handleClickBack = () => {
    handleSlide('back');
  };

  return (
    <>
      <Fab
        background={palette.primary.contrastText}
        icon={
          <ArrowBackIosNewRoundedIcon
            sx={{
              [theme.breakpoints.down('lg')]: {
                fontSize: theme.spacing(2.5),
              },
              color: 'white',
              fontSize: theme.spacing(4),
            }}
          />
        }
        onClick={handleClickBack}
        style={{
          margin: '1rem',
          left: 0,
          transform: 'translate(0)',
          [theme.breakpoints.down('lg')]: {
            width: '28px',
            minHeight: '28px',
            height: '0px',
          },
          position: 'absolute',
        }}
      />
      <Fab
        background={palette.primary.contrastText}
        icon={
          <ArrowForwardIosRoundedIcon
            sx={{
              color: 'white',
              fontSize: theme.spacing(4),
              [theme.breakpoints.down('lg')]: {
                fontSize: theme.spacing(2.5),
              },
            }}
          />
        }
        onClick={handleClickNext}
        style={{
          [theme.breakpoints.down('lg')]: {
            width: '28px',
            minHeight: '28px',
            height: '0px',
          },
          position: 'absolute',
          right: 0,
          transform: 'translate(0)',
          margin: '1rem',
        }}
      />
    </>
  );
}
